import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
export function HiddenProblemSection() {
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-blue-light to-baby-lavender" data-id="element-590">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-591">
        <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 md:p-10 rounded-baby-lg border-2 border-baby-blue shadow-baby-glow animate-fade-in-up" data-id="element-592">
          <div className="flex items-start gap-4 mb-6" data-id="element-593">
            <div className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 bg-baby-gradient-blue rounded-full flex items-center justify-center shadow-baby-soft animate-soft-pulse" data-id="element-594">
              <AlertCircleIcon className="w-6 h-6 sm:w-7 sm:h-7 text-white" data-id="element-595" />
            </div>
            <div data-id="element-596">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-597">
                El Problema Oculto
              </h2>
              <p className="text-base sm:text-lg text-gray-600" data-id="element-598">
                No es que no tengas recetas. No es que te falte información.
              </p>
            </div>
          </div>

          <div className="space-y-4 sm:space-y-6" data-id="element-599">
            <div className="bg-gradient-to-br from-baby-blue-light to-white p-5 sm:p-6 rounded-baby border-2 border-baby-blue-light shadow-baby-soft" data-id="element-600">
              <p className="text-lg sm:text-xl md:text-2xl font-bold text-baby-blue mb-3" data-id="element-601">
                El verdadero problema es:
              </p>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-602">
                Tienes{' '}
                <span className="font-bold text-gray-900" data-id="element-603">
                  DEMASIADA información
                </span>
                , pero nada que puedas aplicar hoy a las 7 PM.
              </p>
            </div>

            <div className="grid sm:grid-cols-3 gap-3 sm:gap-4 stagger-children" data-id="element-604">
              <div className="bg-white p-4 rounded-baby border-2 border-baby-blue-light/50 text-center shadow-baby-soft" data-id="element-605">
                <p className="text-sm font-semibold text-gray-700" data-id="element-606">
                  Ideas sueltas
                </p>
              </div>
              <div className="bg-white p-4 rounded-baby border-2 border-baby-blue-light/50 text-center shadow-baby-soft" data-id="element-607">
                <p className="text-sm font-semibold text-gray-700" data-id="element-608">
                  Posts dispersos
                </p>
              </div>
              <div className="bg-white p-4 rounded-baby border-2 border-baby-blue-light/50 text-center shadow-baby-soft" data-id="element-609">
                <p className="text-sm font-semibold text-gray-700" data-id="element-610">
                  Consejos contradictorios
                </p>
              </div>
            </div>

            <div className="text-center pt-4" data-id="element-611">
              <p className="text-xl sm:text-2xl font-bold text-gray-900 mb-2" data-id="element-612">
                Mucho ruido. Cero sistema.
              </p>
              <p className="text-base sm:text-lg text-gray-600" data-id="element-613">
                Eso es lo que te hace volver a improvisar. Y quedarte con la
                duda:{' '}
                <span className="italic font-semibold text-baby-blue" data-id="element-614">
                  "¿Estaré haciéndolo bien?"
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}